<div id="loader-cube" [class.hidden]="!show">
    <div class="cont">
        <div class="cube1"></div>
        <div class="cube2"></div>
        <div class="cube4"></div>
        <div class="cube3"></div>
    </div>
</div>